import { useState, useEffect } from "react";
import MobileMenu from "./MobileMenu";
import LoginForm from "./LoginForm";
import Header from "./Header.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { scroller } from "react-scroll";

function HeaderOne({ categories, destination }) {
  const [isSticky, setIsSticky] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoginFormOpen, setIsLoginFormOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  // ✅ Scroll to section when navigating from another page
  useEffect(() => {
    if (location.state?.scrollTo) {
      const section = location.state.scrollTo;
      setTimeout(() => {
        scroller.scrollTo(section, {
          smooth: true,
          duration: 600,
          offset: -80,
        });
      }, 400);
    }
  }, [location]);

  
  const handleScrollClick = (section) => {
    if (location.pathname === "/") {
      scroller.scrollTo(section, {
        smooth: true,
        duration: 600,
        offset: -80,
      });
    } else {
      navigate("/", { state: { scrollTo: section } });
    }
  };

  // ✅ Sticky header logic
  useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 500);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <>
      <header className="th-header header-layout1">
       

        {/* ---------- Sticky Main Header ---------- */}
        <div className={`sticky-wrapper ${isSticky ? "sticky" : ""}`}>
          <div className="menu-area">
            <div className="container th-container">
              <div className="row align-items-center justify-content-between">
                {/* Logo */}
                <div className="col-auto">
                  <div className="header-logo">
                    <Link to="/">
                      <img
                        src="/assets/img/logo1.png"
                        alt="Mahakal Yatra"
                        className="main-logo"
                      />
                    </Link>
                  </div>
                </div>

                {/* Navigation */}
                <div className="col-auto me-xl-auto">
                  <nav className="main-menu d-none d-xl-inline-block">
                    <ul>
                      <li>
                        <Link className={location.pathname === "/" ? "active" : ""} to="/">
                          Home
                        </Link>
                      </li>

                      <li>
                        <Link
                          className={location.pathname === "/about" ? "active" : ""}
                          to="/about"
                        >
                          About Us
                        </Link>
                      </li>
                      
                      {/* ✅ Destination Dropdown */}
                      <li className="menu-item-has-children">
                        <Link to="#">Destination</Link>
                        <ul className="sub-menu">
                          {destination?.map((des) => (
                            <li key={des.id}>
                              <Link to={`/destination/${des.id}`}>{des.name}</Link>
                            </li>
                          ))}
                        </ul>
                      </li>

                      {/* ✅ Service Dropdown */}
                      <li className="menu-item-has-children">
                        <Link to="#">Service</Link>
                        <ul className="sub-menu">
                          {categories?.map((category) => (
                            <li key={category.id}>
                              <Link to={`/service/${category.id}`}>
                                {category.name}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </li>

                      {/* ✅ Scroll to Gallery */}
                      <li>
                        <button
                          onClick={() => handleScrollClick("gallery")}
                          style={{
                            background: "none",
                            border: "none",
                            color: "black",
                            cursor: "pointer",
                          }}
                        >
                          Gallery
                        </button>
                      </li>

                      <li>
                        <Link
                          className={location.pathname === "/contact" ? "active" : ""}
                          to="/contact"
                        >
                          Contact Us
                        </Link>
                      </li>

                    </ul>
                  </nav>

                  {/* Mobile Toggle */}
                  <button
                    type="button"
                    className="th-menu-toggle d-block d-xl-none"
                    onClick={() => setIsMobileMenuOpen(true)}
                  >
                    <i className="far fa-bars" />
                  </button>
                </div>
              </div>
            </div>

            {/* Background Mask */}
            <div
              className="logo-bg bg-mask"
              style={{
                WebkitMaskImage: "url(/assets/img/logo_bg_mask.png)",
                maskImage: "url(/assets/img/logo_bg_mask.png)",
              }}
            />
          </div>
        </div>
      </header>

      {/* ---------- Mobile & Login Popups ---------- */}
      <MobileMenu
      isOpen={isMobileMenuOpen}
      onClose={() => setIsMobileMenuOpen(false)}
      categories={categories}
      destination={destination}/>

      <LoginForm
        isOpen={isLoginFormOpen}
        onClose={() => setIsLoginFormOpen(false)}
      />
    </>
  );
}

export default HeaderOne;
